import React from "react";

function GoogleLogoSVG({ height = "24" }) {
    return (
        <svg
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.8859 11.7985C22.8859 10.983 22.8128 10.199 22.6769 9.44623H11.8459V13.8946H18.035C17.7684 15.3321 16.9582 16.5501 15.7403 17.3655V20.251H19.4569C21.6314 18.249 22.8859 15.3008 22.8859 11.7985Z"
                fill="#4285F4"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.8458 23.0369C14.9508 23.0369 17.554 22.0072 19.4568 20.2508L15.7402 17.3653C14.7104 18.0553 13.3931 18.4631 11.8458 18.4631C8.85062 18.4631 6.31539 16.4401 5.41108 13.7219H1.56903V16.7015C3.4613 20.4599 7.35039 23.0369 11.8458 23.0369Z"
                fill="#34A853"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.41117 13.7222C5.18117 13.0322 5.05049 12.2951 5.05049 11.5372C5.05049 10.7792 5.18117 10.0422 5.41117 9.35216V6.37262H1.56913C0.790265 7.92512 0.345947 9.68148 0.345947 11.5372C0.345947 13.3928 0.790265 15.1492 1.56913 16.7017L5.41117 13.7222Z"
                fill="#FBBC05"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.8458 4.61097C13.5343 4.61097 15.0502 5.1912 16.242 6.33075L19.5404 3.03234C17.5488 1.17665 14.9456 0.0371094 11.8458 0.0371094C7.3504 0.0371094 3.4613 2.61415 1.56903 6.37256L5.41108 9.35211C6.31539 6.63393 8.85062 4.61097 11.8458 4.61097Z"
                fill="#EA4335"
            />
        </svg>
    );
}

export default GoogleLogoSVG;
